<div class="card" >
  <ngx-codemirror #cm [options]="codeMirrorOptions" [(ngModel)]='displayData' (codeMirrorLoaded)="onCodeMirrorReady()">
  </ngx-codemirror>
</div>
